import { render, staticRenderFns } from "./BaseModal.vue?vue&type=template&id=16e4b2af&scoped=true&"
import script from "./BaseModal.vue?vue&type=script&lang=js&"
export * from "./BaseModal.vue?vue&type=script&lang=js&"
import style0 from "./BaseModal.vue?vue&type=style&index=0&id=16e4b2af&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e4b2af",
  null
  
)

export default component.exports